export default (function(t, e) {
  return e()
})(this, function() {
  return (function(t) {
    var e = {}
    function n(r) {
      if (e[r]) return e[r].exports
      var o = (e[r] = { i: r, l: !1, exports: {} })
      return t[r].call(o.exports, o, o.exports, n), (o.l = !0), o.exports
    }
    return (
      (n.m = t),
      (n.c = e),
      (n.d = function(t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r })
      }),
      (n.r = function(t) {
        typeof Symbol !== 'undefined' &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
          Object.defineProperty(t, '__esModule', { value: !0 })
      }),
      (n.t = function(t, e) {
        if ((1 & e && (t = n(t)), 8 & e)) return t
        if (4 & e && typeof t === 'object' && t && t.__esModule) return t
        var r = Object.create(null)
        if (
          (n.r(r),
          Object.defineProperty(r, 'default', { enumerable: !0, value: t }),
          2 & e && typeof t !== 'string')
        )
          for (var o in t)
            n.d(
              r,
              o,
              function(e) {
                return t[e]
              }.bind(null, o)
            )
        return r
      }),
      (n.n = function(t) {
        var e =
          t && t.__esModule
            ? function() {
                return t.default
              }
            : function() {
                return t
              }
        return n.d(e, 'a', e), e
      }),
      (n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
      }),
      (n.p = ''),
      n((n.s = 0))
    )
  })([
    function(t, e, n) {
      function r(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n]
          ;(r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            'value' in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r)
        }
      }
      var o = n(1)
      var i = (function() {
        function t(e, n) {
          var r = n.location
          var o = void 0 === r ? 0 : r
          var i = n.distance
          var a = void 0 === i ? 100 : i
          var c = n.threshold
          var s = void 0 === c ? 0.6 : c
          var h = n.maxPatternLength
          var u = void 0 === h ? 32 : h
          var l = n.caseSensitive
          var f = void 0 !== l && l
          var d = n.tokenSeparator
          var v = void 0 === d ? / +/g : d
          var p = n.findAllMatches
          var g = void 0 !== p && p
          var m = n.minMatchCharLength
          var y = void 0 === m ? 1 : m
          var x = n.keys
          var b = void 0 === x ? [] : x
          var M = n.sortFn
          var L =
            void 0 === M
              ? function(t, e) {
                  return t.score - e.score
                }
              : M
          !(function(t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function')
          })(this, t),
            (this.options = {
              location: o,
              distance: a,
              threshold: s,
              maxPatternLength: u,
              isCaseSensitive: f,
              tokenSeparator: v,
              findAllMatches: g,
              minMatchCharLength: y,
              keys: b,
              sortFn: L,
            }),
            (this.list = e)
        }
        var e, n, i
        return (
          (e = t),
          (n = [
            {
              key: 'search',
              value: function(t) {
                var e = new o(t, this.options)
                var n = this._search(e)
                return this._computeScore(n), this._sort(n), this._format(n)
              },
            },
            {
              key: '_search',
              value: function(t) {
                for (var e = this.list, n = {}, r = [], o = 0, i = e.length; o < i; o += 1)
                  for (var a = e[o], c = 0, s = this.options.keys.length; c < s; c += 1) {
                    var h = this.options.keys[c]
                    this._analyze(
                      { key: h, value: a[h], record: a, index: o },
                      { resultMap: n, results: r, fullSearcher: t }
                    )
                  }
                return r
              },
            },
            {
              key: '_analyze',
              value: function(t, e) {
                var n = t.key
                var r = t.value
                var o = t.record
                var i = t.index
                var a = e.fullSearcher
                var c = void 0 === a ? [] : a
                var s = e.resultMap
                var h = void 0 === s ? {} : s
                var u = e.results
                var l = void 0 === u ? [] : u
                if (r != null) {
                  var f = c.search(r)
                  f.isMatch &&
                    (h[i]
                      ? h[i].output.push({
                          key: n,
                          value: r,
                          score: f.score,
                          matchedIndices: f.matchedIndices,
                        })
                      : ((h[i] = {
                          item: o,
                          output: [
                            {
                              key: n,
                              value: r,
                              score: f.score,
                              matchedIndices: f.matchedIndices,
                            },
                          ],
                        }),
                        l.push(h[i])))
                }
              },
            },
            {
              key: '_computeScore',
              value: function(t) {
                for (var e = 0, n = t.length; e < n; e += 1) {
                  for (var r = t[e].output, o = 1, i = 0; i < r.length; i += 1) {
                    o *= r[i].score
                  }
                  t[e].score = o
                }
              },
            },
            {
              key: '_sort',
              value: function(t) {
                t.sort(this.options.sortFn)
              },
            },
            {
              key: '_format',
              value: function(t) {
                for (var e = [], n = 0, r = t.length; n < r; n += 1) {
                  var o = t[n]
                  e.push(o.item)
                }
                return e
              },
            },
          ]) && r(e.prototype, n),
          i && r(e, i),
          t
        )
      })()
      t.exports = i
    },
    function(t, e, n) {
      function r(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n]
          ;(r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            'value' in r && (r.writable = !0),
            Object.defineProperty(t, r.key, r)
        }
      }
      var o = n(2)
      var i = n(3)
      var a = n(6)
      var c = (function() {
        function t(e, n) {
          var r = n.location
          var o = void 0 === r ? 0 : r
          var i = n.distance
          var c = void 0 === i ? 100 : i
          var s = n.threshold
          var h = void 0 === s ? 0.6 : s
          var u = n.maxPatternLength
          var l = void 0 === u ? 32 : u
          var f = n.isCaseSensitive
          var d = void 0 !== f && f
          var v = n.tokenSeparator
          var p = void 0 === v ? / +/g : v
          var g = n.findAllMatches
          var m = void 0 !== g && g
          var y = n.minMatchCharLength
          var x = void 0 === y ? 1 : y
          !(function(t, e) {
            if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function')
          })(this, t),
            (this.options = {
              location: o,
              distance: c,
              threshold: h,
              maxPatternLength: l,
              isCaseSensitive: d,
              tokenSeparator: p,
              findAllMatches: m,
              minMatchCharLength: x,
            }),
            (this.pattern = this.options.isCaseSensitive ? e : e.toLowerCase()),
            this.pattern.length <= l && (this.patternAlphabet = a(this.pattern))
        }
        var e, n, c
        return (
          (e = t),
          (n = [
            {
              key: 'search',
              value: function(t) {
                if ((this.options.isCaseSensitive || (t = t.toLowerCase()), this.pattern === t))
                  return {
                    isMatch: !0,
                    score: 0,
                    matchedIndices: [[0, t.length - 1]],
                  }
                var e = this.options
                var n = e.maxPatternLength
                var r = e.tokenSeparator
                if (this.pattern.length > n) return o(t, this.pattern, r)
                var a = this.options
                var c = a.location
                var s = a.distance
                var h = a.threshold
                var u = a.findAllMatches
                var l = a.minMatchCharLength
                return i(t, this.pattern, this.patternAlphabet, {
                  location: c,
                  distance: s,
                  threshold: h,
                  findAllMatches: u,
                  minMatchCharLength: l,
                })
              },
            },
          ]) && r(e.prototype, n),
          c && r(e, c),
          t
        )
      })()
      t.exports = c
    },
    function(t, e) {
      var n = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g
      t.exports = function(t, e) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : / +/g
        var o = new RegExp(e.replace(n, '\\$&').replace(r, '|'))
        var i = t.match(o)
        var a = !!i
        var c = []
        if (a)
          for (var s = 0, h = i.length; s < h; s += 1) {
            var u = i[s]
            c.push([t.indexOf(u), u.length - 1])
          }
        return { score: a ? 0.5 : 1, isMatch: a, matchedIndices: c }
      }
    },
    function(t, e, n) {
      var r = n(4)
      var o = n(5)
      t.exports = function(t, e, n, i) {
        for (
          var a = i.location,
            c = void 0 === a ? 0 : a,
            s = i.distance,
            h = void 0 === s ? 100 : s,
            u = i.threshold,
            l = void 0 === u ? 0.6 : u,
            f = i.findAllMatches,
            d = void 0 !== f && f,
            v = i.minMatchCharLength,
            p = void 0 === v ? 1 : v,
            g = c,
            m = t.length,
            y = l,
            x = t.indexOf(e, g),
            b = e.length,
            M = [],
            L = 0;
          L < m;
          L += 1
        )
          M[L] = 0
        if (x !== -1) {
          var k = r(e, {
            errors: 0,
            currentLocation: x,
            expectedLocation: g,
            distance: h,
          })
          if (((y = Math.min(k, y)), (x = t.lastIndexOf(e, g + b)) !== -1)) {
            var S = r(e, {
              errors: 0,
              currentLocation: x,
              expectedLocation: g,
              distance: h,
            })
            y = Math.min(S, y)
          }
        }
        x = -1
        for (var C = [], _ = 1, A = b + m, j = 1 << (b - 1), O = 0; O < b; O += 1) {
          for (var P = 0, w = A; P < w; ) {
            r(e, {
              errors: O,
              currentLocation: g + w,
              expectedLocation: g,
              distance: h,
            }) <= y
              ? (P = w)
              : (A = w),
              (w = Math.floor((A - P) / 2 + P))
          }
          A = w
          var I = Math.max(1, g - w + 1)
          var T = d ? m : Math.min(g + w, m) + b
          var B = Array(T + 2)
          B[T + 1] = (1 << O) - 1
          for (var E = T; E >= I; E -= 1) {
            var F = E - 1
            var z = n[t.charAt(F)]
            if (
              (z && (M[F] = 1),
              (B[E] = ((B[E + 1] << 1) | 1) & z),
              O !== 0 && (B[E] |= ((C[E + 1] | C[E]) << 1) | 1 | C[E + 1]),
              B[E] & j &&
                (_ = r(e, {
                  errors: O,
                  currentLocation: F,
                  expectedLocation: g,
                  distance: h,
                })) <= y)
            ) {
              if (((y = _), (x = F) <= g)) break
              I = Math.max(1, 2 * g - x)
            }
          }
          if (
            r(e, {
              errors: O + 1,
              currentLocation: g,
              expectedLocation: g,
              distance: h,
            }) > y
          )
            break
          C = B
        }
        return {
          isMatch: x >= 0,
          score: _ === 0 ? 0.001 : _,
          matchedIndices: o(M, p),
        }
      }
    },
    function(t, e) {
      t.exports = function(t, e) {
        var n = e.errors
        var r = void 0 === n ? 0 : n
        var o = e.currentLocation
        var i = void 0 === o ? 0 : o
        var a = e.expectedLocation
        var c = void 0 === a ? 0 : a
        var s = e.distance
        var h = void 0 === s ? 100 : s
        var u = r / t.length
        var l = Math.abs(c - i)
        return h ? u + l / h : l ? 1 : u
      }
    },
    function(t, e) {
      t.exports = function() {
        for (
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            n = [],
            r = -1,
            o = -1,
            i = 0,
            a = t.length;
          i < a;
          i += 1
        ) {
          var c = t[i]
          c && r === -1
            ? (r = i)
            : c || r === -1 || ((o = i - 1) - r + 1 >= e && n.push([r, o]), (r = -1))
        }
        return t[i - 1] && i - r >= e && n.push([r, i - 1]), n
      }
    },
    function(t, e) {
      t.exports = function(t) {
        for (var e = {}, n = t.length, r = 0; r < n; r += 1) e[t.charAt(r)] = 0
        for (var o = 0; o < n; o += 1) e[t.charAt(o)] |= 1 << (n - o - 1)
        return e
      }
    },
  ])
})
